import React from 'react';
export function Footer() {
  return <footer className="bg-bb-charcoal text-white/70 py-10 px-4 text-center text-sm" data-id="element-102">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-103">
        <div className="flex items-center justify-center gap-2 mb-2" data-id="element-104">
          <span className="text-xl" data-id="element-105">🏀</span>
          <span className="font-display font-bold uppercase text-bb-cream tracking-[0.25em] text-sm" data-id="element-106">
            Basketball Coach's Bible
          </span>
        </div>
        <p data-id="element-107">
          © {new Date().getFullYear()} Basketball Coach's Bible — All rights
          reserved.
        </p>
        <p className="text-xs text-white/55 max-w-2xl mx-auto leading-relaxed" data-id="element-108">
          The content on this page is for informational and educational purposes
          only. It does not replace certified professional coaching credentials.
          Consult a qualified health professional before starting any new
          physical training program.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-white/60" data-id="element-109">
          <a href="#" className="hover:text-bb-orange transition-colors" data-id="element-110">
            Terms & Conditions
          </a>
          <span data-id="element-111">·</span>
          <a href="#" className="hover:text-bb-orange transition-colors" data-id="element-112">
            Privacy Policy
          </a>
          <span data-id="element-113">·</span>
          <a href="#" className="hover:text-bb-orange transition-colors" data-id="element-114">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}